require('./components/logout-action');
const { initSelect2DocumentHandlers } = require('./shared/select2-document-handlers');
const { checkLoadedFileImage } = require('./shared/file-validation');
import { initShabbosClockbar } from './members/shabbos-clockbar.js';
import { formatCurrency } from './pledge-pay/pledge-pay-utils.js';
import { markSettingsNavActive } from './shared/settings-nav.js';
import { cleanupBootstrapModalBody, hideBootstrapModal, initBootstrapModalBodyCleanup } from './shared/bootstrap-modal-cleanup.js';
import { initCsrfRefresh } from './shared/csrf-token.js';
import { numberFormat } from './shared/number-format.js';

function syncManagerKioskNoPrintFromMeta() {
    const meta = document.querySelector('meta[name="manager-kiosk-no-print"]');
    if (meta && meta.getAttribute('content') === '1') {
        window.managerKioskNoPrint = true;
    }
}

syncManagerKioskNoPrintFromMeta();
initShabbosClockbar();

initCsrfRefresh();
initBootstrapModalBodyCleanup();
initSelect2DocumentHandlers();

const isEmpty = str => !str?.length;

function convert_date(value) {
    if (value == null || value === '') {
        return '';
    }

    const date_info = String(value).split('T');

    const date_arr = date_info[0].split("-");
    return date_arr[1] + "/" + date_arr[2] + "/" + date_arr[0];
}

function capLock(e) {
    const kc = e.keyCode ? e.keyCode : e.which;
    const sk = e.shiftKey ? e.shiftKey : ((kc === 16) ? true : false);
    if (((kc >= 65 && kc <= 90) && !sk) || ((kc >= 97 && kc <= 122) && sk))
        document.getElementById('capLockNotice').style.visibility = 'visible';
    else
        document.getElementById('capLockNotice').style.visibility = 'hidden';
}

$(document).on('keypress', '[data-cap-lock-watch]', function (event) {
    capLock(event);
});

$(document).on('click', '[data-click-callback]', function (event) {
    const callback = ($(this).data('click-callback') || '').trim();
    if (!callback) {
        return;
    }
    const callbackName = callback.replace(/\(\s*\)\s*$/, '');
    const callbackFn = window[callbackName];
    if (typeof callbackFn === 'function') {
        event.preventDefault();
        const rawArg = $(this).data('click-arg');
        if (rawArg === undefined || rawArg === null || rawArg === '') {
            callbackFn();
            return;
        }
        const numberArg = Number(rawArg);
        callbackFn(Number.isNaN(numberArg) ? rawArg : numberArg);
    }
});

$(document).on('click', '[data-account-action]', function (event) {
    const action = String($(this).data('account-action') || '').trim();
    if (action === '') {
        return;
    }

    const actionMap = {
        'open-account-settings': 'openAccountSettings',
    };
    const callbackName = actionMap[action] || '';
    const callbackFn = callbackName !== '' ? window[callbackName] : null;
    if (typeof callbackFn === 'function') {
        event.preventDefault();
        markSettingsNavActive(this);
        callbackFn();
    }
});

/* START Re-color checkboxes */
function checkRecolor(box_info, div_info) {
    if ($('#' + box_info.id).is(':checked')) {
        document.getElementById(div_info).style.borderColor = "green";
    } else {
        document.getElementById(div_info).style.borderColor = "var(--border-color)";
    }
}

/* END Re-color checkboxes */

$("#dispSuccess").delay(6000).hide("slow");

/*
 this is a function that works on a class of noSpaces.
 If that class is added to a text box, it will not allow
 them to enter spaces.  It will also strip spaces out of a pasted value
 */
$(document).on('input', '.noSpaces', function () {
    this.value = this.value.replace(/\s/g, '');
});

/* start code for the dropdown from an elipsis in users and charity - must have multiple ones on a page*/
let lastClick = null;

$('.redirect_link').change(function () {
    window.location.href = $(this).val();
});

$(document).on("click", function (event) {
    if ($(event.target).closest("#OpenPullElip, .dropdown-content").length === 0) {
        if (lastClick != null) {
            try {
                document.getElementById("actionDropdown[" + lastClick + "]").classList.remove("showdrop");
            } catch {
            }
            try {
                document.getElementById("actionDropdownMobile[" + lastClick + "]").classList.remove("showdrop");
            } catch {
            }
            lastClick = null;
        }
    }
});

//dropdown for datatable member in manager and users in admin OR ANYWHERE the OpenPullElip pulldown is used
function clearDropdownPosition(el) {
    el.style.position = '';
    el.style.top = '';
    el.style.left = '';
}

function OpenElipsMenu(pass_val) {
    if (lastClick !== undefined && lastClick !== null && lastClick !== pass_val) {
        const lastDropdown = document.getElementById("actionDropdown[" + lastClick + "]");
        if (lastDropdown) {
            lastDropdown.classList.remove("showdrop");
            clearDropdownPosition(lastDropdown);
        }
    }
    const dropdown = document.getElementById("actionDropdown[" + pass_val + "]");
    if (dropdown) {
        const row = dropdown.closest('tr.clickable-row');
        const isExpanded = row && row.classList.contains('expanded');
        const willShow = !dropdown.classList.contains('showdrop');

        dropdown.classList.toggle("showdrop");

        if (isExpanded && willShow) {
            const button = dropdown.previousElementSibling;
            if (button) {
                const rect = button.getBoundingClientRect();
                dropdown.style.position = 'fixed';
                dropdown.style.top = (rect.bottom + window.scrollY) + 'px';
                dropdown.style.left = (rect.left + window.scrollX - 45) + 'px';
            }
        } else if (!willShow) {
            clearDropdownPosition(dropdown);
        }
    }
    lastClick = pass_val;
}

function OpenElipsMenuMobile(pass_val) {
    if (lastClick !== undefined && lastClick !== null && lastClick !== pass_val) {
        document.getElementById("actionDropdownMobile[" + lastClick + "]").classList.remove("showdrop");
    }
    document.getElementById("actionDropdownMobile[" + pass_val + "]").classList.toggle("showdrop");
    lastClick = pass_val;
}


//dropdown activate for add member from manager OR ANYWHERE the OpenPullElip pulldown is used
function OpenMemberAdd() {
    if (lastClick != null) {
        document.getElementById("memberDropdown").classList.remove("showdrop");
    }
    document.getElementById("memberDropdown").classList.toggle("showdrop");
}

document.addEventListener('click', function (event) {
    if (event.target.closest('[data-nav-action="OpenMemberAdd"]')) {
        event.preventDefault();
        OpenMemberAdd();
    }
});

function setFocusForKey(fieldName) {
    const el = document.getElementById(fieldName);
    el?.focus();
    setTimeout(() => el?.focus(), 1);
}

function getPaymentTopModalData(record_id, table_name, url, csrf_token)
{
    const passData = [];
    let result = [false, 'An unknown error occurred, please try again.'];

    $.ajax({
        url: url,
        "_token": csrf_token,
        type: "GET",
        async: false,
        success: function (response) {
            if (!response.success) {
                result = [false, response.error];
                return;
            }
            const main_data = response.main_data;
            const memberName = String(main_data.member_name || main_data.user_name || main_data.name || '').trim()
                || (String(main_data.first_name || '').trim() + ' ' + String(main_data.last_name || '').trim()).trim();
            passData['pay_member_name'] = memberName;

            switch(table_name)
            {
                case "pledge":
                    passData['pay_campaign'] = main_data.title;
                    passData['pay_description'] = main_data.description;
                    passData['pay_date_pledged'] = convert_date(main_data.pledge_date);
                    passData['pay_amount_due'] = '$' + formatCurrency(main_data.balance_due);

                    if(!main_data.frequency_id)
                    {
                        //over-ride the above
                        if(main_data.balance_due === 0)
                        {
                            passData['pay_amount_due'] = 'Paid';
                        }
                    }else{
                        //since this is recurring show the next payment and frequency, otherwise will cause java msg
                        passData['pay_next_payment'] = convert_date(main_data.next_run_date);
                        passData['pay_frequency'] = main_data.frequency_name;
                    }

                    break;
                case "ongoing_donations":
                    //this is for ongoing campaign donations
                    passData['pay_campaign'] = main_data.title;
                    passData['pay_description'] = main_data.comments;
                    passData['pay_date_pledged'] = convert_date(main_data.date_initiated);
                    passData['pay_amount_due'] = '$' + formatCurrency(main_data.balance_due);

                    passData['pay_next_payment'] = convert_date(main_data.next_run_date);
                    passData['pay_frequency'] = main_data.frequency_name;
                    break;
                case "campaign_donations":
                    passData['pay_campaign'] = main_data.title;
                    passData['pay_description'] = main_data.comments;
                    passData['pay_date_pledged'] = convert_date(main_data.date_paid);
                    passData['pay_amount_due'] = 'Paid';
                    passData['pay_next_payment'] = null;
                    passData['pay_frequency'] = null;
                    break;
            }

            if(main_data.original_duration !== 0)
            {
                passData['pay_original_duration'] = main_data.original_duration;
                passData['pay_payments_left'] = main_data.num_left;
            }else{
                passData['pay_original_duration'] = "Ongoing";
                passData['pay_payments_left'] = "Ongoing";
                //over-ride what was already added to the amount due as there is no calc that can be made as it is ongoing
                passData['pay_amount_due'] = '$' + formatCurrency(main_data.amount);
            }
            result = [true, passData];
        },
        error: function() {
            result = [false, 'An unknown error occurred, please try again.'];
        }
    });
    return result;
}

function fetchRecurPayments(url, csrf_token)
{
    let result = [false, 'An unknown error occurred, please try again.'];

    $.ajax({
        url: url,
        "_token": csrf_token,
        type: "GET",
        async: false,
        success: function (response) {
            if (!response.success) {
                result = [false, response.error];
            } else if (response.data.length === 0) {
                result = [false, 'A payment has not been made yet.'];
            } else {
                result = [true, response.data];
            }
        },
        error: function() {
            result = [false, 'An unknown error occurred, please try again.'];
        }
    });

    return result;
}

function validatePledgeDeletable(url, csrf_token)
{
    let answer;
    $.ajax({
        url: url,
        "_token": csrf_token,
        type: "GET",
        async: false,
        success: function (response) {
            if (!response.success) {
                answer = false;
            }else{
                answer = response.delete_me;
            }
        },
        error: function() {
            answer = false;
        }
    });
    return answer;
}

function exposeFunctionsToWindow() {
    if (!('ck_logged_in' in window)) window.ck_logged_in = '';

    Object.assign(window, {
        cleanupBootstrapModalBody,
        hideBootstrapModal,
        initBootstrapModalBodyCleanup,
        isEmpty,
        convert_date,
        capLock,
        numberFormat,
        checkRecolor,
        checkLoadedFileImage,
        OpenElipsMenu,
        OpenElipsMenuMobile,
        OpenMemberAdd,
        setFocusForKey,
        getPaymentTopModalData,
        fetchRecurPayments,
        validatePledgeDeletable,
    });
}

exposeFunctionsToWindow();
